import { t } from "i18next";

import Button from "~/components/buttons/Button/Button";
import Hint from "~/components/Hint";
import SidebarContent from "~/components/Sidebar/components/SidebarContent";
import SidebarFooter from "~/components/Sidebar/components/SidebarFooter";
import SidebarHeader from "~/components/Sidebar/components/SidebarHeader";
import SidebarHeaderHeadline from "~/components/Sidebar/components/SidebarHeaderHeadline";

type Props = {
	onCancel: () => void;
};

const InvoiceAddressNotEditableMessage = ({ onCancel }: Props) => {
	return <div className="auto-grid-sidebar">
		<SidebarHeader><SidebarHeaderHeadline>Rechnungsadresse</SidebarHeaderHeadline></SidebarHeader>
		<SidebarContent>
			<Hint theme="warning"
				  title="Änderung nicht möglich">
				<p>Die Rechnungsadresse kann nicht mehr geändert werden, sobald die Rechnung versendet wurde.</p>
				<p>Das Vorhandensein der Rechnungsadresse ist nur für die Erstellung einer E-Rechnung zwingend
					erfoderlich.</p>
				<p>Sollte dies notwendig sein, muss der Status auf &quot;Freigegeben&quot; zurückgesetzt und die Adresse
					nachgetragen werden.</p>
			</Hint>
		</SidebarContent>
		<SidebarFooter>
			<Button theme="white"
					onClick={onCancel}>
				{t("form:buttonTexts.cancel")}
			</Button>
		</SidebarFooter>
	</div>;
};

export default InvoiceAddressNotEditableMessage;